import {useEffect} from 'react'
import {useInstallPromptStore} from '../state/ui.js'

/**
 * Captures the `beforeinstallprompt` event so the Profile screen can offer an
 * install button. iOS Safari never fires this event — Profile shows a static
 * "Add to Home Screen" hint instead.
 */
export function useInstallPrompt() {
    const event = useInstallPromptStore(state => state.event)
    const setEvent = useInstallPromptStore(state => state.setEvent)
    const clear = useInstallPromptStore(state => state.clear)

    useEffect(() => {
        const onBefore = (e) => {
            e.preventDefault()
            setEvent(e)
        }
        const onInstalled = () => clear()
        window.addEventListener('beforeinstallprompt', onBefore)
        window.addEventListener('appinstalled', onInstalled)
        return () => {
            window.removeEventListener('beforeinstallprompt', onBefore)
            window.removeEventListener('appinstalled', onInstalled)
        }
    }, [setEvent, clear])

    const promptInstall = async () => {
        if (!event)
            return null
        event.prompt()
        const choice = await event.userChoice
        clear()
        return choice.outcome
    }

    return {available: !!event, promptInstall}
}
